import { Box, Container, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/student/Layout/layout";
import SectionCard from "../../../components/student/SectionCard";
import { showSavedExamSubmitMessage } from "../../../helpers/examSubmitMessage";
import { getAllSectionsRequest } from "../../../modules/students-modules/sections/Actions";

const C = {
  primary: "#E85D04",
  muted: "#78716C",
};

const ExamsSectionsList = () => {
  const sections = useSelector((state) => state.sections.sections);
  const isLoading = useSelector((state) => state.sections.isLoading);
  const userData = useSelector((state) => state.user.userData);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllSectionsRequest());
  }, [dispatch]);

  useEffect(() => {
    showSavedExamSubmitMessage();
  }, []);

  const filtered = useMemo(() => {
    const list = Array.isArray(sections)
      ? sections
      : Array.isArray(sections?.data)
        ? sections.data
        : [];
    const subjectId = userData?.subject?.id;
    return list.filter((s) => {
      if (subjectId == null || subjectId === undefined) return true;
      if (s.subject_id == null || s.subject_id === undefined) return true;
      return Number(s.subject_id) === Number(subjectId);
    });
  }, [sections, userData?.subject?.id]);

  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.2xl" h="100%" my="100px" mb="165px" w="100%">
        <VStack spacing={8} h="100%" w="100%" alignItems="stretch">
          <Box w="100%">
            <Heading as="h3" color={C.primary} textAlign="center" w="100%" fontWeight="800">
              Exams
            </Heading>
            <Text mt={2} color={C.muted} fontSize="sm" textAlign="center">
              Browse your sections and continue your exams.
            </Text>
          </Box>

          {filtered.length === 0 && !isLoading ? (
            <Text color={C.muted} fontWeight="600" w="100%" textAlign="center">
              No sections available yet.
            </Text>
          ) : (
            <Flex wrap="wrap" justify="center" gap={3} w="100%">
              {filtered.map((section) => (
                <SectionCard
                  key={section.id}
                  section={section}
                  to={`/exams/chapters/${section.id}?name=${encodeURIComponent(section.name || "")}`}
                  ctaLabel="Continue Learning"
                />
              ))}
            </Flex>
          )}
        </VStack>
      </Container>
    </Layout>
  );
};

export default ExamsSectionsList;
